import React, {Fragment, useState} from 'react';
import i18n from 'i18next';
import {Link, usePage} from '@inertiajs/inertia-react';
import '@inertiajs/inertia-react';
import {OverlayTrigger, Popover, Tooltip} from 'react-bootstrap';
import MyProfileSlider from './MyProfileSlider';
import styles from '../../../sass/components/TopBar.module.scss';
import {TrialBanner} from "@/Components/TopBar/TrialBanner";
import {PaymentErrorBanner} from "@/Components/TopBar/PaymentErrorBanner";
import OrgSwitcher from "@/Components/TopBar/OrgSwitcher";
import LoginSettingsSlider from "@/Components/TopBar/LoginSettingsSlider";
import OriginalProfileSlider from "@/Components/TopBar/OriginalProfileSlider";

export default function TopBar() {
    const props = usePage().props;
    const user = usePage().props.auth.user;
    const currentOrganization = usePage().props.auth.current_organization;
    const [showOriginalProfileSlider, setShowOriginalProfileSlider] = useState(false);
    const [showMyProfile, setShowMyProfile] = useState(false);
    const [showLoginSettings, setShowLoginSettings] = useState(false);
    const features = usePage().props.features;
    const isPlatformUnity = currentOrganization.is_platform_unity;
    const [hideUnpurchasedModules, setHideUnpurchasedModules] = useState(currentOrganization.has_unpurchased_modules_hidden);

    //The original profile slider has been added back in and feature flagged temporarily until we can fully transition to the new profile and login sliders
    const toggleOriginalProfileSlider = () => {
        setShowOriginalProfileSlider(!showOriginalProfileSlider);
    }

    const toggleMyProfile = () => {
        setShowMyProfile(!showMyProfile);
    }

    const toggleLoginSettings = () => {
        setShowLoginSettings(!showLoginSettings);
    }

    const handleHideUnpurchasedModules = (hideUnpurchasedModules) => {
        setHideUnpurchasedModules(hideUnpurchasedModules);
        axios.put(
            route('organization.hide-unpurchased-modules'),
            {hideUnpurchasedModules: hideUnpurchasedModules}
        ).then((response) => {
                location.reload();
            }
        ).catch(error => {
            console.error("Response Status: " + error.response.status + ", Response Message: " + error.response.data.message);
        });
    }

    const isSettingsVisible = () => {
        return currentOrganization.is_a_top_level_parent && currentOrganization.is_owner && isPlatformUnity === false;
    }

    return (
        <Fragment>
            <div className={styles.topBar}>
                <div className={styles.leftWrap}>
                    <OrgSwitcher />
                </div>
                <div className={styles.rightWrap}>
                    {isSettingsVisible() &&
                    <OverlayTrigger
                        trigger="click"
                        placement="bottom"
                        rootClose
                        overlay={
                            <Popover id={`popover-settings`}>
                                <Popover.Body>
                                    <div className="popover-settings-container">
                                        <div className="settings-header">{i18n.t("top-bar.settings.header")}</div>
                                        <div className="settings-text">{i18n.t("top-bar.settings.text")}</div>
                                        <div className="explore-modules-toggle">
                                            <div onClick={() => handleHideUnpurchasedModules(false)}
                                                 className={hideUnpurchasedModules ?  'toggle-show':'toggle-show active'}>
                                                {i18n.t("top-bar.settings.toggle.show")}
                                            </div>
                                            <div onClick={() => handleHideUnpurchasedModules(true)}
                                                 className={hideUnpurchasedModules ?  'toggle-hide active':'toggle-hide'}>
                                                {i18n.t("top-bar.settings.toggle.hide")}
                                            </div>
                                        </div>
                                    </div>
                                </Popover.Body>
                            </Popover>
                        }>
                        <div className={styles.settings}>
                            <i className="fas fa-cog"></i>
                        </div>
                    </OverlayTrigger>
                    }
                    <OverlayTrigger
                        placement="bottom"
                        overlay={
                            <Tooltip id={`tooltip-bottom`}>
                                {i18n.t("top-bar.help")}
                            </Tooltip>
                        }>
                        <div className={styles.help}>
                            {isPlatformUnity &&
                                <a href="https://help.myamplify.io/" target="_blank">
                                    <i
                                        data-testid="top_bar-link-help"
                                        className="fas fa-question-circle"
                                    >
                                    </i>
                                    </a>
                                }
                                {!isPlatformUnity &&
                                    <a href="https://support.parishsoft.com/hc/en-us" target="_blank">
                                        <i
                                            data-testid="top_bar-link-help"
                                            className="fas fa-question-circle"
                                        >
                                        </i>
                                    </a>
                                }
                            </div>
                        </OverlayTrigger>
                    <div className={styles.userProfile}>
                        <OverlayTrigger
                            trigger="click"
                            placement="bottom"
                            rootClose
                            overlay={
                                <Popover id={`popover-user-profile`}>
                                    {features['individuals'] && !showMyProfile && !showLoginSettings && (
                                    <Popover.Body>
                                        <div className="user-profile-popover">
                                            <button data-testid="navbar_avatar_menu-btn-my_profile"
                                                    className="btn btn-toolbar link" onClick={() => {
                                                document.body.click();
                                                toggleMyProfile();
                                            }}>
                                                {i18n.t("top-bar.my-profile")}
                                            </button>
                                            <button data-testid="navbar_avatar_menu-btn-login_settings"
                                                    className="btn btn-toolbar link" onClick={() => {
                                                document.body.click();
                                                toggleLoginSettings();
                                            }}>
                                                {i18n.t("top-bar.login-settings")}
                                            </button>
                                            {(user.belongs_to_multiple_organizations && !features['show_org_switcher']) &&
                                                <Link data-testid="navbar_avatar_menu-btn-switch_organization"
                                                      href={route('organization.select')} onClick={() => {
                                                    document.body.click()
                                                }} method="get" as="button" className="btn btn-toolbar link">
                                                    {i18n.t("top-bar.switch-organization")}
                                                </Link>}
                                            {user.can.access_nova &&
                                                <a data-testid="navbar_avatar_menu-btn-unity_admin" href="/unity"
                                                   className="btn btn-toolbar link">
                                                    Access Unity Admin
                                                </a>}
                                            <a data-testid="navbar_avatar_menu-btn-logout" href={route('logout')}
                                               className="btn btn-toolbar link">
                                                {i18n.t("top-bar.log-out")}
                                            </a>
                                        </div>
                                    </Popover.Body>
                                    )}
                                    {!features['individuals'] && (
                                    <Popover.Body>
                                        <div className="user-profile-popover">
                                            <button data-testid="navbar_avatar_menu-btn-my_profile" className="btn btn-toolbar link" onClick={() => {
                                                document.body.click();
                                                toggleOriginalProfileSlider();
                                            }}>
                                                {i18n.t("top-bar.my-profile")}
                                            </button>
                                            {(user.belongs_to_multiple_organizations && !features['show_org_switcher']) &&
                                                <Link data-testid="navbar_avatar_menu-btn-switch_organization" href={route('organization.select')} onClick={() => {
                                                    document.body.click()
                                                }} method="get" as="button" className="btn btn-toolbar link">
                                                    {i18n.t("top-bar.switch-organization")}
                                                </Link>}
                                            {user.can.access_nova && <a data-testid="navbar_avatar_menu-btn-unity_admin" href="/unity" className="btn btn-toolbar link">
                                                Access Unity Admin
                                            </a>}
                                            <a data-testid="navbar_avatar_menu-btn-logout" href={route('logout')} className="btn btn-toolbar link">
                                                {i18n.t("top-bar.log-out")}
                                            </a>
                                        </div>
                                    </Popover.Body>
                                    )}
                                </Popover>
                            }>
                            <div className={styles.avatarWrap} data-testid="navbar_avatar-btn">
                                <div className={styles.avatar}>
                                    <img src={user.avatars.sm} alt={`${user.first_name} ${user.last_name} avatar`}/>
                                </div>
                            </div>
                        </OverlayTrigger>
                    </div>
                </div>
            </div>
            {features['checkout'] && <TrialBanner trialCount={currentOrganization.trial_count}></TrialBanner>}
            <PaymentErrorBanner failedPayment={currentOrganization.failed_payment}></PaymentErrorBanner>
            <OriginalProfileSlider show={showOriginalProfileSlider} props={props} toggleOriginalProfileSlider={toggleOriginalProfileSlider}/>
            <MyProfileSlider show={showMyProfile} props={props} userUuid={user.uuid} organizationUuid={currentOrganization.uuid} toggleMyProfile={toggleMyProfile}/>
            <LoginSettingsSlider show={showLoginSettings} props={props} toggleLoginSettings={toggleLoginSettings} toggleMyProfile={toggleMyProfile}/>
        </Fragment>
    );
}
